module.exports = "<div class=\"alert alert-dismissible\" [ngClass]=\"Success ? 'alert-success': 'alert-danger'\" *ngIf=\"Show\">\n  <button type=\"button\" data-dismiss=\"alert\" aria-hidden=\"true\" class=\"close\">×</button>\n  {{Msg}}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/alert/alert.component.html
// module id = ../../../../../src/app/shared/component/alert/alert.component.html
// module chunks = main